var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 19.5C14.6458 19.5 16.3802 18.835 17.8281 17.505C19.276 16.175 20 14.5178 20 12.5333C20 10.5489 19.276 8.89167 17.8281 7.56167C16.3802 6.23167 14.6458 5.56667 12.625 5.56667H4.75L8 2.27333L6.25 0.5L0 6.83333L6.25 13.1667L8 11.3933L4.75 8.1H12.625C13.9375 8.1 15.0781 8.52222 16.0469 9.36667C17.0156 10.2111 17.5 11.2667 17.5 12.5333C17.5 13.8 17.0156 14.8556 16.0469 15.7C15.0781 16.5444 13.9375 16.9667 12.625 16.9667H3.75V19.5H12.625Z",
    fill: "#6C6C6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).ac457d174c97c5e72d021daba3780b91.svg";
export { ForwardRef as ReactComponent };